export {default as TitleCommonLayout} from './components/titleCommonLayout'
